import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const Container = styled.nav`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
`;

const Crumb = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  color: ${({ $active, theme }) => ($active ? theme.colors.text.primary : theme.colors.primary.main)};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};

  &:hover {
    ${({ $active, theme }) => !$active && `color: ${theme.colors.primary.dark};`}
  }
`;

const Separator = styled(ChevronRight)`
  color: #A0A8B4;
  flex-shrink: 0;
`;

/**
 * @param {Array} items - [{ label: 'Firmalar', path: '/tenants' }, { label: 'Demo Comp' }]
 * Last item has no path and is rendered as active (non-clickable).
 * `plain: true` renders an intermediate crumb as plain text too — used when the target page
 * exists but the current user can't reach it (a link there would be a dead end).
 */
export default function Breadcrumbs({ items = [] }) {
  const history = useHistory();

  return (
    <Container>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        const isPlain = isLast || item.plain === true;
        return (
          <React.Fragment key={i}>
            {i > 0 && <Separator size={14} />}
            <Crumb
              $active={isPlain}
              onClick={() => !isPlain && item.path && history.push(item.path)}
            >
              {item.label}
            </Crumb>
          </React.Fragment>
        );
      })}
    </Container>
  );
}
